<template>
    <section>
        <div>
            <form @submit.prevent="changePassword" novalidate>
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('392')}}
                {{$t('426')}}
                <!-- 새로운 비밀번호를 입력하세요.<br>
                문자와 숫자를 조합하여 8자리 이상 입력 시 강력한 비밀 보호를 받으실 수 있습니다. -->
            </div>
            <div class="mgt-38">
                <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
                    :class="submitState && passwordInvalidCheck ? 'mdc-text-field--invalid' : ''"
                    id="passwordEl"
                >
                    <i class="material-icons mdc-text-field__icon">
                        {{validIcon}}
                    </i>
                    <input type="password" class="mdc-text-field__input"
                        id="password"
                        name="password"
                        v-model="password"
                        v-validate="'required|min:10|verify_password'"
                        ref="password"
                    >
                    <div class="mdc-notched-outline">
                        <div class="mdc-notched-outline__leading"></div>
                        <div class="mdc-notched-outline__notch">
                        <label for="tf-outlined" class="mdc-floating-label">
                            {{$t('393')}}
                            <!-- 새 비밀번호 -->
                        </label>
                        </div>
                        <div class="mdc-notched-outline__trailing"></div>
                    </div>
                    
                </div>
                <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23"  :class="submitState && passwordInvalidCheck ? 't-color-red1' : ''">
                    <span>
                        {{$t('394')}}
                        <!-- * 문자, 숫자를 조합하여 8자 이상을 사용하세요. -->
                    </span>
                </div>
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red">
                    {{$t('395')}}
                    <!-- 다음 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindPw()" type="button">
                    {{$t('396')}}
                    <!-- 취소 -->
                </button>
            </div>
            </form>
        </div>
    </section>
            

    
</template>

<script>
/**
 * 비밀번호 재설정 Step4 컴포넌트 (reset password Step4 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import {mapState, mapMutations} from 'vuex'
import {findPwMixin} from '@/mixins/findPw.js'

export default {
    data() {
        return {
            password: '',
            passwordTextField: null,
            submitState: false,
            validIcon: ''
        }
    },

    mixins: [findPwMixin],

    computed: {
        ...mapState('findPw',{
            findPw : state => state,
        }),

        passwordInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('password')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = 'check'
                }
            }

            this.passwordTextField.valid === !returnValue ? '' : this.passwordTextField.valid = !returnValue
            return returnValue
        }
    },

    mounted() {
        // 토큰값이 없을 경우 Step1로 이동(If there is no token value, go to Step1)
        if (!this.findPw.step3.token) {
            this.$moveLogin()
        }

        this.setMaterialUi()
        this.$refs.password.focus()
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findPw', ['SET_PASSWORD']),

        setMaterialUi() {
            this.passwordTextField = new MDCTextField(document.querySelector('#passwordEl'))
            this.passwordTextField.useNativeValidation = false

            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 패스워드 유효성 체크 및 다음화면으로 이동(validation password and move next screen)
        changePassword() {
            this.$validator.validateAll().then((resultValid) => {
                this.submitState = true
                if (resultValid) {
                    this.SET_PASSWORD(this.password)
                    this.$router.push({
                        name: 'FindPwStep5', 
                    })
                }else {
                    this.$refs.password.focus()
                }
            })
        }

    },
}
</script>